export const encode64 = (value: string) => btoa(value);

export const decode64 = (encoded: string) => atob(encoded);
